<mg-table [collectionComponent]="this" matSort stickyHeaders>

    <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Code </th>
        <td mat-cell *matCellDef="let row"> {{row.code}} </td>
    </ng-container>

	<ng-container matColumnDef="relatie">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Relatie </th>
        <td mat-cell *matCellDef="let row"> {{row.relatie.naam1}} </td>
    </ng-container>

	<ng-container matColumnDef="projectgroep">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Projectgroep </th>
        <td mat-cell *matCellDef="let row"> {{row.projectgroep?.omschrijving}} </td>
    </ng-container>

	<ng-container matColumnDef="projectstatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
        <td mat-cell *matCellDef="let row"> {{getStatus(row.status)}} </td>
    </ng-container>

	<ng-container matColumnDef="projectleider">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Projectleider </th>
        <td mat-cell *matCellDef="let row"> {{row.projectleider?.naam}} </td>
    </ng-container>

	<ng-container matColumnDef="referentieKlant">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Referentie Klant </th>
        <td mat-cell *matCellDef="let row"> {{row.referentieKlant}} </td>
    </ng-container>

	<ng-container matColumnDef="omschrijving2">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Omschrijving </th>
        <td mat-cell *matCellDef="let row"> {{row.omschrijving2}} </td>
    </ng-container>

	<ng-container matColumnDef="datumAanvraag">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum Aanvraag </th>
        <td mat-cell *matCellDef="let row"> {{row.datumAanvraag | date}} </td>
    </ng-container>

	<ng-container matColumnDef="datumOrder">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum Order </th>
        <td mat-cell *matCellDef="let row"> {{row.datumOrder | date}} </td>
    </ng-container>

    <ng-container matColumnDef="datumOBAangemaakt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum Bevestigd </th>
        <td mat-cell *matCellDef="let row"> {{row.datumOBAangemaakt | date:'short'}} </td>
    </ng-container>

    <ng-container matColumnDef="datumOBVerstuurd">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum Verstuurd </th>
        <td mat-cell *matCellDef="let row"> {{row.datumOBVerstuurd | date:'short'}} </td>
    </ng-container>

	<ng-container matColumnDef="datumStart">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum Start </th>
        <td mat-cell *matCellDef="let row"> {{row.datumStart | date }} </td>
    </ng-container>

	<ng-container matColumnDef="datumPlan">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum Planning </th>
        <td mat-cell *matCellDef="let row"> {{row.datumPlan | date}} </td>
    </ng-container>

	<ng-container matColumnDef="datumGereed">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum Gereed </th>
        <td mat-cell *matCellDef="let row"> {{row.datumGereed | date}} </td>
    </ng-container>

</mg-table>
